import React from "react";
import { Box } from "@mui/material";
import { MessagesTable } from "components/organisms/MessagesTable/MessagesTable";

export const Messages = () => (
  <Box>
    <MessagesTable />
  </Box>
);
